import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/medical-records';

const getByPatient = async (
	patientId: string,
): Promise<MedicalRecords.MedicalRecord> => {
	const { data } = await api.get(`${DOMAIN}/patient/${patientId}`);
	return data;
};

const getSessions = async (
	recordId: string,
	params: MedicalRecords.MedicalRecordSessionParams,
): Promise<MedicalRecords.GetMedicalRecordSessionsResponse> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(
		`${DOMAIN}/${recordId}/sessions?${queryParams}`,
	);
	return data;
};

const getSession = async (
	recordId: string,
	sessionId: string,
): Promise<MedicalRecords.MedicalRecordSession> => {
	const { data } = await api.get(
		`${DOMAIN}/${recordId}/sessions/${sessionId}`,
	);
	return data;
};

const patchSession = async (
	recordId: string,
	sessionId: string,
	body: MedicalRecords.UpdateMedicalRecordSessionBody,
): Promise<MedicalRecords.MedicalRecordSession> => {
	const { data } = await api.patch(
		`${DOMAIN}/${recordId}/sessions/${sessionId}`,
		body,
	);
	return data;
};

const patchAssessment = async (
	recordId: string,
	assessmentId: string,
	body: MedicalRecords.UpdateMedicalRecordAssessmentBody,
): Promise<MedicalRecords.Assessment> => {
	const { data } = await api.patch(
		`${DOMAIN}/${recordId}/assessments/${assessmentId}`,
		body,
	);
	return data;
};

const patchPlan = async (
	recordId: string,
	planId: string,
	body: MedicalRecords.UpdateMedicalRecordPlanBody,
): Promise<MedicalRecords.Plan> => {
	const { data } = await api.patch(
		`${DOMAIN}/${recordId}/plans/${planId}`,
		body,
	);
	return data;
};

const MedicalRecordService = {
	getByPatient,
	getSessions,
	getSession,
	patchSession,
	patchAssessment,
	patchPlan,
};

export { MedicalRecordService };
